module.exports = __webpack_public_path__ + "img/ctycxc.78fe0249.png";